/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { debounce } from 'throttle-debounce';

import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';

import SearchIcon from '@mui/icons-material/SearchOutlined';
import HighlightOffIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoadingIcon from '../common/icons/loading.svg';

import { parsePdf } from './common/utils';
import { useMuPDF } from './common/mupdf-context';
import { magazine } from './common/ducks';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.handleSearchDebounced = debounce(500, this.handleSearch);
    this.state = {
      processing: false,
    };
  }

  handleSearch = event => {
    const { setSearchResult, setSearchInput, doc } = this.props;
    this.setState({ processing: true });
    const searchInput = event.target.value;
    const isCaseSensitive = false;

    if (searchInput === '' || !doc) {
      setSearchInput(searchInput);
      setSearchResult([]);
      this.setState({ processing: false });
      return;
    }

    try {
      const searchResult = parsePdf(doc, searchInput, isCaseSensitive);
      setSearchInput(searchInput);
      setSearchResult(searchResult);
    } catch (e) {
      console.error('[SearchBar] Search failed:', e);
      setSearchInput(searchInput);
      setSearchResult([]);
    }
    this.setState({ processing: false });
  };

  handleBackClick = () => {
    const { toggleThumbs, inputRef } = this.props;
    inputRef.current.focus();
    toggleThumbs();
  };

  render() {
    const { onClose, inputRef, showThumbs } = this.props;
    const { processing } = this.state;
    return (
      <Wrapper>
        <StyledFormControl>
          <SearchInput
            id="input-with-icon-adornment"
            ref={inputRef}
            label="Search"
            placeholder="Search"
            autoFocus
            onChange={e => {
              e.persist();
              this.handleSearchDebounced(e);
            }}
            startAdornment={
              <InputAdornment position="start">
                {processing ? ( // eslint-disable-line no-nested-ternary
                  <StyledLoadingImg src={LoadingIcon} alt="Loading" />
                ) : showThumbs ? (
                  <SearchIcon />
                ) : (
                  <Button onClick={this.handleBackClick}>
                    <StyledArrowBackIcon />
                  </Button>
                )}
              </InputAdornment>
            }
          />
          <Button onClick={onClose}>
            <StyledHighlightOffIcon />
          </Button>
        </StyledFormControl>
      </Wrapper>
    );
  }
}

const Button = styled.button`
  border: none;
  background: none;
  margin: 0;
  padding: 0;
`;

const Wrapper = styled.div`
  position: fixed;
  align-items: center;
  flex-direction: row;
  height: 50px;
  width: 80%;
  max-width: 400px;
  background-color: white;
  border: grey 2px solid;
  border-radius: 20px 0 20px 0px;
  top: 5px;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
`;

const StyledFormControl = styled(FormControl)`
  && {
    position: absolute;
    width: 90%;
    display: flex;
    left: 20px;
    bottom: 8px;
    align-items: center;
    flex-direction: row;
    flex: 1;
    z-index: 999;
  }
`;

const SearchInput = styled(Input)`
  && {
    flex: 2;
    underline: black;
    margin-right: 6px;

    &::after {
      border-color: #f69a79;
    }
  }
`;

const StyledHighlightOffIcon = styled(HighlightOffIcon)`
  && {
    margin: 0;
    height: 1.2em;
    width: 1.2em;
    cursor: pointer;
  }
`;

const StyledLoadingImg = styled.img`
  animation: spin 0.8s ease;
  animation-iteration-count: infinite;
`;

const StyledArrowBackIcon = styled(ArrowBackIcon)`
  cursor: pointer;
`;

const mapStateToProps = state => ({
  showThumbs: state.magazine.showThumbs,
});

const ConnectedSearchBar = connect(
  mapStateToProps,
  {
    toggleThumbs: magazine.toggleThumbs,
    setSearchInput: magazine.setSearchInput,
    setSearchResult: magazine.setSearchResult,
  },
  null,
  { forwardRef: true }
)(SearchBar);

export default React.forwardRef((props, ref) => {
  const { doc } = useMuPDF() || {};
  return <ConnectedSearchBar {...props} doc={doc} inputRef={ref} />;
});
